import _regeneratorRuntime from "/root/code/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useRef, useState, useEffect, useCallback } from "react";
import useSWR from "swr";
import { fetcher } from "../../../api/index";
import { transformLocationDataRow, trackInitialLocation, trackSetLocation } from "./utils";
import { INITIAL_LOCATION_ENDPOINT, SET_LOCATION_ENDPOINT, SET_LOCATION_ERROR } from "./consts";
import { DeliveryLocationMobile } from "./DeliveryLocationMobile";
import { DeliveryLocationDesktop } from "./DeliveryLocationDesktop";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var DeliveryLocation = function DeliveryLocation(_ref) {
  var _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var renderCount = useRef(0);

  var _useState = useState(false),
      showInput = _useState[0],
      setShowInput = _useState[1];

  var _useState2 = useState(),
      selectedLocation = _useState2[0],
      setSelectedLocation = _useState2[1];

  var _useState3 = useState(undefined),
      serverError = _useState3[0],
      setServerError = _useState3[1];

  var _useSWR = useSWR(INITIAL_LOCATION_ENDPOINT, fetcher),
      userLocationResponse = _useSWR.data;

  var setNewDeliveryLocation = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(selectedLocation) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setServerError(undefined);
              _context.prev = 1;
              _context.next = 4;
              return fetcher({
                url: SET_LOCATION_ENDPOINT,
                method: "POST",
                data: "postcodeId=".concat(selectedLocation.value.toString())
              });

            case 4:
              setSelectedLocation(selectedLocation);

              if (true) {
                setTimeout(function () {
                  window.location.reload();
                }, 100);
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              setServerError(SET_LOCATION_ERROR);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [setSelectedLocation]);
  var handleItemSelected = useCallback(function (selected) {
    setShowInput(false);

    if (!selected) {
      return;
    }

    setNewDeliveryLocation(selected);
  }, [setShowInput, setNewDeliveryLocation]);
  var handleAlertHide = useCallback(function () {
    return setServerError(undefined);
  }, []);
  useEffect(function () {
    var _userLocationResponse;

    if (userLocationResponse !== null && userLocationResponse !== void 0 && (_userLocationResponse = userLocationResponse.data) !== null && _userLocationResponse !== void 0 && _userLocationResponse.postcode) {
      setSelectedLocation(transformLocationDataRow(userLocationResponse.data.postcode));
    }
  }, [userLocationResponse, setSelectedLocation]);
  useEffect(function () {
    if (renderCount.current === 1 && selectedLocation) {
      trackInitialLocation(selectedLocation.title);
    } else if (selectedLocation) {
      trackSetLocation(selectedLocation.title);
    }
  }, [selectedLocation]);
  useEffect(function () {
    renderCount.current++;
  }, [selectedLocation]);

  if (!selectedLocation) {
    return null;
  }

  var deliveryLocationProps = {
    selectedLocation: selectedLocation,
    showInput: showInput,
    setShowInput: setShowInput,
    handleItemSelected: handleItemSelected,
    handleAlertHide: handleAlertHide,
    serverError: serverError
  };

  if (isMobile) {
    return ___EmotionJSX(DeliveryLocationMobile, deliveryLocationProps);
  }

  return ___EmotionJSX(DeliveryLocationDesktop, deliveryLocationProps);
};